// src/Component/Tour/Described/AIAgentTour.js
import React from "react";

const AIAgentTour = () => {
  return (
    <div>
      <p>
        Click on the Live agent and manage your live agent settings, configure
        call routing, and handle customer support calls from here.
      </p>
    </div>
  );
};

export default AIAgentTour;

export const EnableLiveAgentToggle = () => {
  return (
    <div>
      {" "}
      <p>Copy the app name and past it in the client config</p>
    </div>
  );
};

// ============================================================
// EnableGuestLiveChat
// ============================================================
// Description shown for the guest_live_chat_enabled toggle
// inside Live Agent → Live User Settings.
// Referenced from tourConfig.js as:
//   import AIAgentTour, { EnableGuestLiveChat } from "...";
// ============================================================
export const EnableGuestLiveChat = () => {
  return (
    <div>
      <p>
        Control whether <strong>unauthenticated visitors</strong> can start a
        live chat with your support team.
      </p>
      <ul style={{ marginTop: "8px", paddingLeft: "18px" }}>
        <li>
          <strong>Enabled</strong> — guests can chat without signing in. Great
          for public marketing sites.
        </li>
        <li>
          <strong>Disabled</strong> — only logged-in users can chat. Best for
          customer portals and internal tools.
        </li>
      </ul>
      <p style={{ marginTop: "10px", color: "#64748b" }}>
        💡 This flag is read by the chat widget at load time and can also be
        enforced server-side at the socket layer.
      </p>
    </div>
  );
};

// ============================================================
// EnableVideoSettings
// ============================================================
// Description shown for the Video Call Media section inside
// Live Agent → Live User Settings. Two independent toggles
// (camera + microphone) that decide what media the widget
// requests when a video call starts.
// Referenced from tourConfig.js as:
//   import AIAgentTour, { EnableVideoSettings } from "...";
// ============================================================
export const EnableVideoSettings = () => {
  return (
    <div>
      <p>
        Configure which media streams the widget requests when a visitor
        starts a video call with a live agent.
      </p>
      <ul style={{ marginTop: "8px", paddingLeft: "18px" }}>
        <li>
          <strong>Camera</strong> — whether the widget asks for the visitor's
          video. Off → audio-only calls.
        </li>
        <li>
          <strong>Microphone</strong> — whether the widget asks for the
          visitor's audio. Off → video-only calls.
        </li>
      </ul>
      <p style={{ marginTop: "10px", color: "#64748b" }}>
        💡 Turning <strong>both</strong> off disables video calls entirely.
        Live-agent text chat still works.
      </p>
    </div>
  );
};

// ============================================================
// NOTE: CredentialsAuthKey / CredentialsRestKey live in
// CredentialsTour.js and are already imported from there
// in tourConfig.js. Keeping them commented here as a
// reminder that they belong to a different module, or
// delete this block if it's no longer useful.
// ============================================================
// export const CredentialsAuthKey = () => { ... };
// export const CredentialsRestKey = () => { ... };